<template>
    <v-card>
        <v-card-text  class="d-flex justify-center">
            <div style="max-width: 320px;">
                <login-buttons @confirm="onLoginSuccess" :providers="['google', 'azure']" mode="lti" :text='$t("LTI_LOGIN_STEP_TEXT")' />
            </div>
        </v-card-text>
    </v-card>
</template>

<script lang="ts">
import { Component, Vue } from "vue-property-decorator";
import LoginButtons from '@components/login/LoginButtons.vue';
import { useApiClientStore } from "@/stores/apiClientStore";
import { useAuthenticationStore } from "@/stores/authenticationStore";
import { useEntitlementStore } from "@/stores/entitlementStore";

@Component({components: {LoginButtons}})
export default class LoginStep extends Vue {
    get isLoading() { return useApiClientStore().isLoading; }
    get ltiToken() { return useAuthenticationStore().ltiToken; }
    tryLogin = () => useAuthenticationStore().tryLogin();
    fetchClaims = () => useEntitlementStore().fetchClaims();

    async onLoginSuccess()
    {
        await this.tryLogin();
        await this.fetchClaims();
        this.$emit('confirm')
    }
}
</script>